import { connect, FormikValues } from 'formik'
import styled from 'styled-components'
import { string } from 'yup'

import Label from '@/components/Label'
import { VariableInputContainer } from '@/pages/SpaceAppBuilder/components/StyledComponents'
import VariableAutoComplete from '@/pages/SpaceAppBuilder/components/VariableInputDropdown/AutoCompleteVariableInput'
import { useWorkflowFeature } from '@/pages/SpaceAppBuilder/FeaturesPage/WorkflowFeatureContext'
import { FieldTypes, InvokeLambdaStepData, StepData, Variable } from '@/pages/SpaceAppBuilder/utilities/interfaces'

type InvokeLambdaProps = {
  readOnly?: boolean
}

const StyledVariableInputContainer = styled(VariableInputContainer)`
  padding-top: 10px;
`

const getValidationSchema = () => {
  return {
    inputData: string().required('Input Data is required'),
    lambdaArn: string().required('Lambda ARN is required')
  }
}

const getInitialValues = (stepData: InvokeLambdaStepData): StepData => {
  return {
    inputData: stepData.inputData ?? '',
    lambdaArn: stepData.lambdaArn
  }
}

const InvokeLambdaOperation = ({ formik, readOnly = false }: InvokeLambdaProps & FormikValues) => {
  const { getVariablesForStep } = useWorkflowFeature()
  const variables = getVariablesForStep()

  const onSelectVariable = (variable: Variable, formikName: string) => {
    formik.setFieldValue(formikName, variable.name)
  }

  return (
    <>
      <Label className="mt-4" required>
        {'Input Data'}
      </Label>
      <StyledVariableInputContainer>
        <VariableAutoComplete
          readOnly={readOnly}
          name={'stepData.inputData'}
          variables={variables}
          validVariableTypes={[FieldTypes.OBJECT, FieldTypes.ANY]}
          placeholder={'Select a variable to pass as input data to the Lambda function.'}
          // @ts-expect-error
          onSelectOption={onSelectVariable}
          showValidationMessage={true}
          required
          formik={formik}
        />
      </StyledVariableInputContainer>
      <Label required>{'Lambda ARN'}</Label>
      <StyledVariableInputContainer>
        <VariableAutoComplete
          readOnly={readOnly}
          name={'stepData.lambdaArn'}
          variables={variables}
          validVariableTypes={[FieldTypes.STRING]}
          placeholder={`Enter Lambda ARN or select a variable containing the Lambda ARN.`}
          // @ts-expect-error
          onSelectOption={onSelectVariable}
          showValidationMessage={true}
          required
        />
      </StyledVariableInputContainer>
    </>
  )
}

export default connect(InvokeLambdaOperation)

export { getInitialValues, getValidationSchema }
